const carousel = {
  Trynow: 'Try now',
  Enter: 'Enter',
  Comingsoon: 'Coming soon, stay tuned',
  Applicationsuccessful: 'Applicationsuccessful',
  Unsuccessful: 'Unsuccessful',
  slides1Title: 'Cross-analysis methods for multiple data sources',
  slides1DescHtml: 'Multi-dimensional data is a tailored cross-analysis tool for processing multiple data sources; it supports flexible combination by users, without the need for SQL programming skills or developer support. Data extraction and exploration can be easily accomplished with simple drag-and-drop operations.',
  slides1Title: 'Cross-analysis methods for multiple data sources',
  slides1ProductName: 'Multi-dimensional data',
  slides2Title: 'One-stop to view comprehensive model indicators',
  slides2DescHtml: 'The Model Library is capable of conducting comprehensive model indicator image analysis, assisting users in model analysis through more comprehensive and finely granular scenario-based model images.',
  slides2ProductName: 'Model Library',
  slides3Title: 'Model Intelligent level in the market',
  slides3DescHtml: 'By evaluating the level of model intelligence comprehensively through five dimensions—functional breadth, functional depth, user experience, user insights, and OTA growth potential—our users can better assess the competitive strength and comparing models in terms of intelligence.',
  slides4Title: 'How to adjust car purchase benefits',
  slides4DescHtml: 'By conducting long-term and stable monitoring, a comprehensive structured rights and benefits database is established. This facilitates our users to understand car purchase benefits and marketing activities provided by automakers. <br />It assists you in conducting comparative analysis of car purchase rights and marketing for various brands and models, and grasping the trends in marketing development.',
}

const products = {
  productDesc1: 'Trace the development of automaker and the overall market',
  productDesc2: 'Cross-analysis for detailed research',
  productDesc3: 'Analyze complicated issues rapidly',
  productDesc4: 'Grasp data instantly for easy processing',
  Other: 'Other',
}

const solutions = {
  solutionsDesc1: 'An intelligent system for making leading strategies',
  solutionsDesc2: 'Scenario-based decision-making system',
  solutionsDesc3: 'A BI platform in automobile industry',
}

export default {
  ...carousel,
  ...products,
  ...solutions,
  headerLogoTitle: 'i-Analytics',
  Homepage: 'Homepage',
  products: 'Data-based Product',
  productsTip: 'Provide necessary statistics for automakers to manage effectively and visualize data',
  solutions: 'Scenario-based Solution',
  solutionsTip: 'Starting from scenarios, deeply understand the needs for user decision-making, and build intelligent decision-making scenarios',
  detail: 'Detail',
  viewDetail: 'Detail',
  IndustryInsights: 'Industry Insight',
  IndustryInsightsTip: 'Focused on the latest trends in the automotive field, collecting and researching market data, business policies, cutting-edge new energy technologies, key automotive companies, and popular vehicle dynamics from a professional perspective',
  Login: 'Log in',
  LoginSlogen1: 'A world-leading',
  LoginSlogen2: 'data-based automobile platform',
  loginTypePassword: 'Password login',
  vertifycodeLogin: 'By verification code',
  qrcodeLogin: 'Scan to log in',
  loginTypeOther: 'Other login method',
  changePassword: 'Change Password',
  account: 'account',
  accountPlaceholder: 'Please enter your login account',
  accountError: 'Please enter the correct login account',
  password: 'password',
  passwordPlaceholder: 'Please enter your login password',
  passwordFormatError: 'Password format error, please re-enter',
  protocolChecked1: "I've read and agree with the",
  protocolChecked2: 'Service Agreement',
  protocolChecked3: 'Privacy Agreement',
  passwordFree: '7-day auto-login',
  mobileAndEmail: 'Telephone/E-mail',
  mobileNo: 'Phone number',
  vertifyCode: 'Verification code',
  mobileAndEmailPlaceholder: 'Please enter your phone number or e-mail address',
  mobileAndEmailError: 'Please enter the correct phone number or email address',
  getVertifycode: 'Obtain verification code',
  getVertifycodePlaceholder: 'Please enter the verification code you received',
  vertifycodeError: 'Verification code input error, please re-enter',
  qrcodeText1: 'Your WeChat account has not been linked to an iWays account yet,',
  qrcodeText2: 'Verification code login binding WeChat',
  qrcodeText3: 'Scan the code to quickly log in later',
  qrcodeText4: 'After binding your account, you can log in by scanning a QR code with WeChat',
  refreshqrcode: 'Refresh QR code',
  agreeUserAuth: 'Please confirm the terms',
  newPassword: 'New password',
  newPasswordPlaceholder: 'Please enter a new password',
  confirmPassword: 'Confirm password',
  agenInputPassword: 'Please enter the new password again',
  agenInputPasswordError: 'The passwords filled in twice are inconsistent',
  contact1: 'Problems?',
  contact2: 'Please contact us',
  contact3: 'customer service hotline',
  contact4: 'E-mail',
  trial_application_submitted_successfully: 'Your application for trial is submitted',
  your_trial_application_has_been_successfully_submitted: 'Dear user, your application for trial is submitted, and our customer service will contact your soon.',
  vertifycodeSendSuccess: 'Verification code sent successfully',
  loginSuccess: 'Login succeeded',
  LoginException: 'Login exception',
  Applyfortrial: 'Apply for trial',
  Applyfortrial2: 'Please fill an application for trial',
  name: 'Name',
  namePlaceholder: 'Please enter your name',
  company: 'Company',
  companyPlaceholder: 'Please enter your company name',
  Trialproduct: 'Trial product (optional)',
  Nextverification: 'Next, verification by phone number',
  Alreadyaccount: 'Already have an account? Log in',
  nameError: 'Please enter the correct name',
  companyError: 'Please enter the correct company name',
  Pleasechooseproduct: 'Please choose which product you want to try',
  selectPls: 'Please choose',
  Quicksearch: 'Quick search',
  Verificationbyphone: 'Verification by phone number',
  Pleasetrial: 'Please fill an application for trial',
  mobilePlaceholder: 'Please enter your phone number',
  Emailoptional: 'E-mail (optional)',
  emailPlaceholder: 'Please enter your e-mail address',
  Applynow: 'Apply now',
  mobilePlaceholderError: 'Please enter the correct phone number',
  enterLessThan: 'Please enter less than {num} characters',
  emailError: 'Please enter the correct email address',
  swipingSide: 'Swiping to the right side',
  Verified: 'Verified, over {percent} of users',
  VerificationFailed: 'Verification failed, drag the slider to merge the floating images correctly',
  Verifiedpass: 'Pass',
  backTop: 'TOP',
  Customerservicecenter: 'Customer service center',
  Hotline: 'Hotline',
  Email: 'E-mail',
  WAYSProfile: 'WAYS Profile',
  ScantoFollowUs: 'Scan to Follow Us',
  Contactus: 'Contact us',
  Waysaddress: 'Unit 101 & 102, Block 6, 1st South Street, Haizhu Topchain Link, No. 88 of Xinjiao Middle Road, Haizhu District, Guangzhou, Guangdong Province',
  ServiceProduct: 'Service & Product',
  WeidianZhijian: 'Weidian Zhijian',
  DaaSAuto: 'DaaS-Auto',
  Companystrength: 'Company strength',
  ITSupport: 'IT Support',
  ModelingTechnique: 'Modeling Technique',
  AutomobileBigData: 'Automobile Big Data',
  CustomizedService: 'Customized Service',
  AboutUs: 'About Us',
  PrivacyLegal: 'Privacy & Legal',
  CopyrightWays: 'Copyright @ 2009-{year} Guangzhou WAYS Information Technology Co., Ltd. All rights reserved',
  GuangdongICPFilingNo: 'Guangdong ICP Filing No. 09206296',
  GuangdongPublicSecurityNetworkFilingNo: 'Guangdong Public Security Network Filing No. 44010602007083',
}
